import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSliderChange } from '@angular/material/slider';
import { DisplaySettings } from '../display-settings';
import * as settings from '../../common/settings';
import * as aspSettings from '../../asp/aspSettings';
import { constsMngr } from '../../common/consts';
import { ColorPickerComponent } from '@core_n/common/color-picker/color-picker.component';
import { ColorPickerService } from '@core_n/common/color-picker/color-picker.service';
import { MapMngr } from '../../asp/MapMngr';
import { ZIndexMngr } from '@core_n/common/ZIndexMngr';
import { Animations } from '@core_n/Animations';

@Component({
  selector: 'tracks-settings',
  templateUrl: './acvec-settings.component.html',
  styleUrls: ['../display-filter.component.scss'],
  animations: [
    Animations.WindowOpenCloseFadeHeight
  ]
})

export class AcousticVectorSettingsComponent extends ZIndexMngr implements AfterViewInit {
  static readonly DIALOG_ID = "Acoustic Vector Settings";

  @ViewChild('AcSelectedColorButton', { read: ElementRef }) private AcSelectedColorButton: ElementRef;
  @ViewChild('AcTextColorButton', { read: ElementRef }) private AcTextColorButton: ElementRef;

  private currentAcSelectedColor: string;
  private currentAcTextColor: string;

  pointElements: string[] = [];
  pointElementsOn = settings.userSettings.pointElementsOn;

  acousticElements: string[] = [];
  acousticElementsOn = settings.userSettings.acousticElementsOn;

  private defaultStyleColor: string;

  AcousticLifeTime: number;

  constructor(public dialogRef: MatDialogRef<AcousticVectorSettingsComponent>,
    private colorPickerSvc: ColorPickerService,
    elementRef: ElementRef) {
    super(elementRef);
    for (let i = 0; i < constsMngr.pointDisplayElementCount(); i++)
      this.pointElements.push(constsMngr.pointDisplayElementTitle(i));

    for (let i = 0; i < constsMngr.acousticDisplayElementCount(); i++)
      this.acousticElements.push(constsMngr.acousticDisplayElementTitle(i));

    let style = getComputedStyle(document.body);
    this.defaultStyleColor = style.getPropertyValue('--default-color');

    this.currentAcSelectedColor = settings.userSettings.acousticSelectedColor;
    this.currentAcTextColor = settings.userSettings.acousticTextColor;
    this.AcousticLifeTime = settings.userSettings.acousticLifeTime;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.windowVisible.next(true);
    })
  }

  onAcousticElemBtnClick(acousticElem) {
    settings.userSettings.toggleAcousticElementOn(acousticElem);
  }

  isColorPickerActive() {
    return this.colorPickerSvc.isColorPickerShown();
  }

  async onAcSelectedColorClick() {
    let color = await this.colorPickerSvc.showColorPicker(this.AcSelectedColorButton, this.currentAcSelectedColor);
    if (color) {
      this.currentAcSelectedColor = color;
      settings.userSettings.setAcousticSelectedColor(color);
    }
  }

  colorPickerIconColorAcSelected() {
    return `linear-gradient(${this.currentAcSelectedColor}, ${this.defaultStyleColor})`;
  }

  async onAcTextColorClick() {
    let color = await this.colorPickerSvc.showColorPicker(this.AcTextColorButton, this.currentAcTextColor);
    if (color) {
      this.currentAcTextColor = color;
      settings.userSettings.setAcousticTextColor(color);
    }
  }

  colorPickerIconColorAcText() {
    return `linear-gradient(${this.currentAcTextColor}, ${this.defaultStyleColor})`;
  }

  minBrightness() {
    return 0;
  }

  maxBrightness() {
    return 100;
  }

  liftimeVectorSliderChanged(event: MatSliderChange) {
    settings.userSettings.setAcousticLifeTime(event.value);
  }
}
